import { useState } from 'react';
import { Banner, Button, Icon } from '@pwc/pwc-deals-ui';
import { Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { helpGuideLink, junctionNextUrls } from './Constants';

import styles from './ProjectSwitchBanner.module.scss';

export const ProjectSwitchBanner = () => {
  const { t } = useTranslation();
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  let newProjectLink = junctionNextUrls.prod;

  if (window.location.href.includes('-dev')) {
    newProjectLink = junctionNextUrls.dev;
  } else if (window.location.href.includes('-qa')) {
    newProjectLink = junctionNextUrls.qa;
  } else if (window.location.href.includes('-uat')) {
    newProjectLink = junctionNextUrls.uat;
  } else if (window.location.href.includes('-stage')) {
    newProjectLink = junctionNextUrls.stage;
  } else if (window.location.href.includes('-load')) {
    newProjectLink = junctionNextUrls.load;
  } else if (window.location.href.includes('-patch')) {
    newProjectLink = junctionNextUrls.patch;
  }

  return (
    <Banner
      className={
        isBannerVisible
          ? styles['project-switch-banner']
          : styles['project-switch-banner-hidden']
      }
      text={
        <>
          <div className={styles['newgen-project-container']}>
            <div className={styles['banner-content']}>
              <div className={styles['info-icon']}>
                <Icon
                  name="information"
                  width="24"
                  height="24"
                  className="fill icon-grey"
                />
              </div>
              <div className={styles['text-content']}>
                <span className={styles['project-new-gen-junction-text']}>
                  {t('newGenProjectsText')}
                </span>{' '}
                <Link
                  className={styles['try-it-here-link']}
                  href={newProjectLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('tryHere')}
                </Link>
                .{' '}
                <span className={styles['learn-platform-text']}>
                  {t('learnPlatform')}
                </span>{' '}
                <Link
                  className={styles['help-guide-link']}
                  href={helpGuideLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('projectHelpGuides')}
                  <span className={styles['box-arrow-link']}>
                    <Icon
                      name="box-arrow-up-right"
                      width="16"
                      height="16"
                      className="fill icon-orange box-arrow-up-right-icon"
                    />
                  </span>
                </Link>
              </div>
            </div>
            <div className={styles['close-button-container']}>
              <Button
                onClick={() => setIsBannerVisible(!isBannerVisible)}
                className="button-no-underline"
              >
                <Icon
                  name="close"
                  width="16"
                  height="16"
                  className="fill icon-orange"
                />
              </Button>
            </div>
          </div>
        </>
      }
      icon={undefined}
      notice={undefined}
      dataTestId={undefined}
    />
  );
};

export default ProjectSwitchBanner;
